import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#FFFFFF",
    },
    secondary: {
      main: "#8F201B",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#f9f9f9",
    },
  },
  typography: {
    fontFamily: 'Open Sans', // Set your custom font here
  },
  components: {
    // Inputs
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #23A5EB`,
            },
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#23A5EB",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#8F201B', // checked color
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#8F201B', // checked color
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(143, 32, 27, 0.15)',
          },
          '&.Mui-selected:hover': {
            backgroundColor: 'rgba(143, 32, 27, 0.15)',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(143, 32, 27, 0.15)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(143, 32, 27, 0.15)',
          },
          '&.Mui-selected:hover': {
            backgroundColor: 'rgba(143, 32, 27, 0.15)',
          },
        },
      },
    },
  },
});

export default theme;
